import { render, staticRenderFns } from "./PrivateInfo.vue?vue&type=template&id=7c944aa0&scoped=true&"
import script from "./PrivateInfo.vue?vue&type=script&lang=js&"
export * from "./PrivateInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrivateInfo.vue?vue&type=style&index=0&id=7c944aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c944aa0",
  null
  
)

export default component.exports